import { api } from '@/api/client'

import type { OccupancyRow, TrainingFrequencyBucket } from './statistics'

export type MemberActivityReport = {
  reference_at: string
  members_total: number
  active_14: number
  active_21: number
  active_30: number
}

export type TrainingFrequencyRow = {
  bucket: TrainingFrequencyBucket
  sort_order: number
  member_count: number
  avg_per_week: number | null
}

type ReportRange = {
  from: string
  to: string
}

export async function getOccupancyReport(range: ReportRange): Promise<OccupancyRow[]> {
  const { data } = await api.GET('/api/v1/reports/occupancy', { params: { query: { from: range.from, to: range.to } } })
  return data!
}

export async function getMemberActivityReport(range: Pick<ReportRange, 'to'>): Promise<MemberActivityReport | null> {
  const { data } = await api.GET('/api/v1/reports/member-activity', { params: { query: { to: range.to } } })
  return data ?? null
}

export async function getTrainingFrequencyReport(range: ReportRange): Promise<TrainingFrequencyRow[]> {
  const { data } = await api.GET('/api/v1/reports/training-frequency', { params: { query: { from: range.from, to: range.to } } })
  return data!.map((row) => ({ ...row, bucket: row.bucket as TrainingFrequencyBucket }))
}
